import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import { styles } from "../Styles";
import { observer } from "mobx-react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import TableSortLabel from "@mui/material/TableSortLabel";
import Typography from "@mui/material/Typography";

class ProjectTableBaseline extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      orderBy: "time",
      data: this.props.data,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }
  }

  handleRequestSort = (event, property) => {
    const isAsc = this.state.orderBy === property && this.state.order === "asc";
    this.setState({ order: isAsc ? "desc" : "asc" });
    this.setState({ orderBy: property });
    this.setState({
      data: this.stableSort(
        this.state.data,
        this.getSorting(this.state.order, this.state.orderBy)
      ),
    });
  };

  desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  getSorting(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.desc(a, b, orderBy)
      : (a, b) => -this.desc(a, b, orderBy);
  }

  sortHandler = (property) => (event) => {
    this.handleRequestSort(event, property);
  };

  render() {
    return (
      <div>
        <Paper>
          <Typography variant="h6">{this.props.tableName}</Typography>
          <Table>
            <TableHead>
              <TableRow>
                {this.props.sortHeaders.map((sortHead) => (
                  <TableCell
                    key={sortHead.id}
                    align="left"
                    padding={sortHead.disablePadding ? "none" : "normal"}
                    sortDirection={
                      this.state.orderBy === sortHead.id
                        ? this.state.order
                        : false
                    }
                  >
                    <TableSortLabel
                      active={this.state.orderBy === sortHead.id}
                      direction={
                        this.state.orderBy === sortHead.id
                          ? this.state.order
                          : "asc"
                      }
                      onClick={this.sortHandler(sortHead.id)}
                    >
                      {sortHead.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.data.map((row) => {
                return (
                  <TableRow key={row.num}>
                    <TableCell>
                      <IconButton onClick={() => this.props.move(row.uId)}>
                        {this.props.moveIcon}
                      </IconButton>
                    </TableCell>
                    <TableCell>{row.num}</TableCell>
                    <TableCell>{row.period}</TableCell>
                    <TableCell style={{ align: "left" }}>{row.time}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  }
}

ProjectTableBaseline.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(observer(ProjectTableBaseline));
